<template>
  <v-btn
    @click="event"
    :disabled="isDisabled"
    icon
  >
    <v-icon>
      {{iconStr}}
    </v-icon>
  </v-btn>
</template>
<script>
  export default {
    props: [
      'event',
      'isDisabled',
      'iconStr'
    ],
    name: 'IconButton',
  }
</script>